export default [
  {
    path: "/aca4d48c-ce01-4cb3-bc49-f76bbcc5b39b",
    children: [
      {
        path: "examiners",
        name: "examiners",
        component: () => import("@/views/examiner/list.vue"),
        meta: {
          title: "Examiners",
          authRequired: true,
          acc: 'y48691',
        },
      },
      {
        path: "aca4d48c-ce01-4cb3-bc49-f76i8",
        name: "new-examiners",
        component: () => import("@/views/examiner/new.vue"),
        meta: {
          title: "New Examiners",
          authRequired: true,
          acc: 'y32170'
        },
      },
      {
        path: "view-examiner",
        name: "viewExaminer",
        component: () => import("@/views/examiner/view.vue"),
        meta: {
          title: "Examiner",
          authRequired: true,
          acc: 'y29449'
        },
      },
  
      {
        path: "examiners-assignment",
        name: "assignmentExaminer",
        component: () => import("@/views/assignment/new.vue"),
        meta: {
          title: "Assign Examiner",
          authRequired: true,
          acc: 'y29034'
        },
      },
      
    ],
  },

  {
    path: "/aca4d48c-ce01-4cb3-bcs49-f76bbcc5b39b",
    children: [
      {
        path: "213131",
        name: "assignments",
        component: () => import("@/views/assignment/list.vue"),
        meta: {
          title: "Assigned Schools",
          authRequired: true,
        },
      },
      {
        path: "adad-23-asd-23324",
        name: "assignment-scores",
        component: () => import("@/views/assignment/scores-list.vue"),
        meta: {
          title: "School Scores",
          authRequired: true,
          acc: 'y80384'
        },
      },
      {
        path: "aa231-9j92d-109e24",
        name: "score-input",
        component: () => import("@/views/assignment/score-input.vue"),
        meta: {
          title: "Enter Scores",
          authRequired: true,
          acc: 'y80384'
        },
      },
      {
        path: "aa231-9j92d-10Qw24",
        name: "score-update",
        component: () => import("@/views/assignment/score-update.vue"),
        meta: {
          title: "Update Entered Scores",
          authRequired: true,
          acc: 'y80384'
        },
      },
    ],
  },
];
